export { PagePanel } from './page-panel';
